import isNumber from "lodash.isnumber";
const urlAccountRegistration = "/api/account/registration/";
const urlAccountLogin = "/api/account/login/";
/** Link at feedback page  */

const urlFeedbackPage = "/feedback/";
/** Link at natural-person-form page  */

const urlNaturalPersonFormPage = "/statistics/natural-person/";
/** Link at natural-person-form page  */

const urlRedirectStatisticsInfoPage = "/statistics/info/";
/** Link at partners page  */

const urlPartnersPage = "/domains/";
/** Link at page with License Agreement Offer */

const urlOfferPage = "/offer/";
/** Link at privacy page  */

const urlPrivacyPage = "/privacy/";
/** Link at services offer page */

const urlServicesOfferPage = "/agreement/";
/** Link at my books page */

const urlMyBooksPage = "/books/";
/** Reader page url */

const urlReaderPage = bookId => `/books/${bookId}/reader/`;
/** Link at Book Success page */


const urlBookSuccessPage = bookId => `/books/${bookId}/success/`;
/** Link at list of proofread items (page url) */


const urlProofreadLandingPage = "/services/proofread/";
const urlProofreadLandingPageOrder = "/services/proofread/#order";
const urlCirculationLandingPage = "/services/circulation/";
/** Link at order proofread form (page url)  */

const urlProofreadOrderPage = "/orders/proofread/";
const urlCirculationPage = "/orders/?currentTab=circulation";

const urlCirculationViewPage = circulationId => `/orders/${circulationId}/`;

const urlCirculationCreate = (bookId, circulationId) => {
  // Add circulationId as get param for restore data previous order
  const extendGetParam = isNumber(circulationId) ? `?circulationId=${circulationId}` : "";
  return `/orders/circulation/create/${bookId}/${extendGetParam}`;
};

const urlMyModerationQueuePage = "/moderation/circulation/queue/my/";

const urlViewModerationPage = circulationId => `/moderation/circulation/${circulationId}/`;
/** Link at faq about pricing */


const urlFaqPricing = "/faq/pricing/";
/** Link at faq about pricing royalty */

const urlFaqPricingRoyalty = "/faq/pricing/#royalty";
/** Link at faq about license exclusive */

const urlFaqLicenseExclusive = "/faq/license/#exclusive";
/** Link at faq about license non exclusive */

const urlFaqLicenseNonExclusive = "/faq/license/#non-exclusive";
/** Link at faq about license non exclusive */

const urlFaqPreparingBook = "/faq/first-step/#recomendation";
const urlFaqNewAccount = "/faq/first-step/#new-account";
const urlFaqPrintOnDemand = "/faq/print-on-demand/";
const urlFaqStatistics = "/faq/statistics/";
const urlFaqLicense = "/faq/license/";
const urlFaqEbook = "/faq/ebook/";
const urlFaqBookCard = "/faq/ebook/#book-card";
const urlFaqHowToTitle = "/faq/ebook/#editing-metadata";
const urlFaqMetadataSubscription = "/faq/ebook/#editing-metadata";
const urlFaqHowToGenre = "/faq/ebook/#editing-metadata";
const urlFaqHowToTags = "/faq/ebook/#editing-metadata";
const urlFaqIllustrationCC0 = "/faq/restrictions/#illustration-cco";
/** Link at faq about upload user book */

const urlFaqUploadBook = "/faq/upload-book/";
const urlFaqDrafts = "/faq/chernoviki/";
const urlFaqCirculation = "/faq/circulation/";
const urlRegistrationProfile = "/faq/registration/#profile";
/** Link at proofread time (page url) */

const urlProofreadTimeFaqPage = "/faq/proofreading/#proofreading-time";
/** Link at proofread faq calculation (page url) */

const urlProofreadCalculationFaqPage = "/faq/proofreading/#text-calculation";
/** Link at master tabs with meta */

const urlMasterMetaTab = "?currentTab=meta";
/** Link at services page */

const urlServicesPage = "https://selfpub.ru/services/";
/** Link at litres.ru  */

const urlLitres = "https://www.litres.ru/";
/** Link at mybook.ru  */

const urlMybook = "https://mybook.ru/";
const urlMyShop = "https://my-shop.ru/";
/** Link at blog.selfpub.ru  */

const urlSelfpubBlog = "https://blog.selfpub.ru/";
const urlBlogCirculationFinish = `${urlSelfpubBlog}circulation-finish`;
const urlBlogPrintOnDemand = `${urlSelfpubBlog}print-on-demand`;
const urlBlogMybook = `${urlSelfpubBlog}mybook`;
const urlBlogPromoAdvice = `${urlSelfpubBlog}promo-advice`;
const urlBlogAnnotation = `${urlSelfpubBlog}annotation`;
const urlBlogTagsForEBook = `${urlSelfpubBlog}tags-for-ebook`;
const urlBlogEBook = `${urlSelfpubBlog}e-book`;
const urlBlogPriceForFook = `${urlSelfpubBlog}priceforbook`;
const urlBlogCatalogLitres = `${urlSelfpubBlog}catalog-litres`;
const urlBlogMakingWonderfulCover = `${urlSelfpubBlog}making-wonderful-cover`;
const urlBlogFindIllustrations = `${urlSelfpubBlog}find-illustrations`;
const urlBlogHowLitresWorks = `${urlSelfpubBlog}howlitresworks`;
/** Link at services.selfpub.ru  */

const urlServicesTildaPage = "https://services.selfpub.ru/";
const urlServiceHelpWriter = `${urlServicesTildaPage}helpwriter/`;
const urlServiceBookPromotion = `${urlServicesTildaPage}promotion/?utm_source=lkbanner&utm_medium=reklama&utm_campaign=test1`;
const urlServiceBookCoverMaker = `${urlServicesTildaPage}design/?utm_source=splk&utm_medium=promo&utm_campaign=cover&utm_content=lk1`;
const urlServicePageMaker = `${urlServicesTildaPage}pagemaker/`;
const urlServiceAnnotation = `${urlServicesTildaPage}annotation/`;
/** Link at ebukva.litres.ru  */

const urlEbukvaTerms = "https://ebukva.litres.ru/terms-2025/";
const urlEbukva = "https://ebukva.litres.ru/";

const getTrackingUrl = trackCode => `https://www.pochta.ru/tracking#${trackCode}`;

const supportEmailUrl = "mailto:support@selfpub.ru";
const litresLogoSrc = "/static/i/litres_logo.svg";
const mybookLogoSrc = "/static/i/mybook_logo.svg";
const urlApiMetaClient = "/api/meta/client/";
const urlGoogleMeasurementProtocol = "https://www.google-analytics.com/collect";
const urlLitresPartnershipAgreement = "https://www.litres.ru/o-kompanii/partneram/partnerskoe-soglashenie/";
const urlLitresPartnershipAgreementReferralProgram = "https://www.litres.ru/o-kompanii/partnerskie-programmy/referalnye-partnery/#q-2";
export { urlApiMetaClient, urlGoogleMeasurementProtocol, urlAccountRegistration, urlAccountLogin, urlNaturalPersonFormPage, urlRedirectStatisticsInfoPage, urlFeedbackPage, urlPartnersPage, urlOfferPage, urlPrivacyPage, urlServicesOfferPage, urlMyBooksPage, urlReaderPage, urlBookSuccessPage, urlProofreadLandingPage, urlProofreadLandingPageOrder, urlCirculationLandingPage, urlProofreadOrderPage, urlCirculationPage, urlCirculationViewPage, urlCirculationCreate, urlMyModerationQueuePage, urlViewModerationPage, urlFaqPricing, urlFaqPricingRoyalty, urlFaqLicenseExclusive, urlFaqLicenseNonExclusive, urlFaqPreparingBook, urlFaqNewAccount, urlFaqPrintOnDemand, urlFaqStatistics, urlFaqLicense, urlFaqEbook, urlFaqBookCard, urlFaqHowToTitle, urlFaqMetadataSubscription, urlFaqHowToGenre, urlFaqHowToTags, urlFaqUploadBook, urlFaqDrafts, urlFaqCirculation, urlFaqIllustrationCC0, urlRegistrationProfile, urlProofreadTimeFaqPage, urlProofreadCalculationFaqPage, urlMasterMetaTab, urlServicesPage, urlLitres, urlMybook, urlMyShop, urlSelfpubBlog, urlBlogCirculationFinish, urlBlogAnnotation, urlBlogTagsForEBook, urlBlogEBook, urlBlogPriceForFook, urlBlogCatalogLitres, urlBlogPrintOnDemand, urlBlogMakingWonderfulCover, urlBlogFindIllustrations, urlBlogHowLitresWorks, urlBlogMybook, urlBlogPromoAdvice, urlServiceHelpWriter, urlServiceBookPromotion, urlServicePageMaker, urlServiceAnnotation, urlServiceBookCoverMaker, urlEbukvaTerms, urlEbukva, getTrackingUrl, supportEmailUrl, litresLogoSrc, mybookLogoSrc, urlLitresPartnershipAgreement, urlLitresPartnershipAgreementReferralProgram };